const state = {
  listaEventParticipants: [],
  eventParticipant: {
    id: null,
    evento: { id: null },
    registro: { id: null },
    inscritoEm: null,
  },
}

export default state
